export default __webpack_public_path__ + "static/media/d4.4f3df96b.jpg";